import React, { useState } from 'react';
import { Box } from '@mui/material';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer';
import CallsResultsWrapper from './CallsResults';
import PriorityWrapper from './Priority';

const titleMap = {
    0: 'Chamados',
    1: 'Prioridade'
};

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return <CallsResultsWrapper />;
        case 1:
            return <PriorityWrapper />;
        default:
            return null;
    }
};

export const Calls = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }
        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'Chamados',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Prioridade',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        }
    ];

    return (
        <Box className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box>
                <ChartsContainer
                    title={titleMap[activeIndexLocal]}
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};